"use client";

import { Badge, cn } from "@atlas/core";
import type { IBadgeStripItem } from "@models";

interface IBadgeStripProps {
  items: IBadgeStripItem[];
  className?: string;
}

export function BadgeStrip({ items, className }: IBadgeStripProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex w-full flex-wrap items-center gap-2", className)}>
      {items.map((item, index) => (
        <Badge
          key={item.id ?? index}
          size={item.size ?? "sm"}
          variant={item.variant}
          appearance={item.appearance}
          className={cn("w-fit", item.className)}>
          {item.label}
        </Badge>
      ))}
    </div>
  );
}
